module.exports = __webpack_public_path__ + "static/media/SCR-A-new4.f9622369.mp3";